var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { ref: "dropdown", staticClass: "dropdown dropdown-notifications" },
    [
      _c(
        "a",
        {
          staticClass: "nav-link dropdown-toggle",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.toggleDropdown.apply(null, arguments)
            }
          }
        },
        [
          _c("i", {
            class: ["icon-notification", !_vm.hasUnread ? "hide-count" : ""],
            attrs: { "data-count": _vm.total }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-container" }, [
        _vm.hasUnread
          ? _c("div", { staticClass: "dropdown-toolbar" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasUnread,
                      expression: "hasUnread"
                    }
                  ],
                  staticClass: "dropdown-toolbar-actions"
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.markAllRead.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Mark all as read")]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "dropdown-notification-menu" },
          [
            _vm._l(_vm.notifications, function(notification) {
              return _c("notification", {
                key: notification.id,
                attrs: { notification: notification },
                on: {
                  read: function($event) {
                    return _vm.markAsRead(notification)
                  }
                }
              })
            }),
            _vm._v(" "),
            !_vm.hasUnread
              ? _c(
                  "li",
                  {
                    staticClass: "notification notification--empty align-c-hlp"
                  },
                  [
                    _vm._v(
                      "\n        You don't have any unread notifications.\n      "
                    )
                  ]
                )
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.hasUnread
          ? _c("div", { staticClass: "dropdown-footer align-c-hlp" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.fetch(null)
                    }
                  }
                },
                [_vm._v("View All")]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37e15f3e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e15f3e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/NotificationsDropdown.vue
// module id = 347
// module chunks = 1 2